import ExtellioLogo from 'components/ExtellioLogo';
import React from 'react';
import './hero.less';

const Hero = ({ branded, style, children }) => (
  <div className={`hero${branded ? ' branded' : ''}`} style={style}>
    {branded && <div className="logo"><ExtellioLogo /></div>}
    {children}
  </div>
);

export default Hero;
